<div class="horizontal-page-header">
    <ng-content></ng-content>
</div>

